function fnLoadAndPlayScrollingVideo(video) {
    if (!video) return;
    
    var dataSrc = video.getAttribute('data-src');
    if (dataSrc && !video.src) {
        video.src = dataSrc;
        video.load();
        video.addEventListener('canplay', function onCanPlay() {
            video.removeEventListener('canplay', onCanPlay);
            video.play().catch(function() {});
        }, { once: true });
    } else {
        video.play().catch(function() {});
    }
}

function fnScrollingTextVideos(i, oSection) {

    const textItems = document.querySelectorAll(".text-item");
    const videoItems = document.querySelectorAll(".video-item");

    if(textItems && videoItems) {
        textItems.forEach((textItem, index) => {
            gsap.fromTo(
              textItem,
              { autoAlpha: 0.2 },
              {
                autoAlpha: 1,
                scrollTrigger: {
                  trigger: textItem,
                  start: "top 55%+=100",
                  end: "bottom 55%-=100",
                  scrub: true, // Enable smooth transition based on scroll position
                  onEnter: () => {
                    // Activate corresponding video
                    videoItems.forEach((videoItem, vidIndex) => {
                      if (vidIndex === index) {
                        videoItem.classList.add("active");
                        if(videoItem.querySelector("video")) {
                            fnLoadAndPlayScrollingVideo(videoItem.querySelector("video"));
                        }
                      } else {
                        videoItem.classList.remove("active");
                        if(videoItem.querySelector("video")) {
                            videoItem.querySelector("video").pause();
                        }
                      }
                    });
                  },
                  onEnterBack: () => {
                    // Re-activate video when scrolling back up
                    videoItems.forEach((videoItem, vidIndex) => {
                      if (vidIndex === index) {
                        videoItem.classList.add("active");
                        if(videoItem.querySelector("video")) {
                            fnLoadAndPlayScrollingVideo(videoItem.querySelector("video"));
                        }
                      } else {
                        videoItem.classList.remove("active");
                        if(videoItem.querySelector("video")) {
                            videoItem.querySelector("video").pause();
                        }
                      }
                    });
                  },
                },
              }
            );
        });

    }
}